<template>
  <div ref="chart" style="width: 100%;height:400px;"></div>
</template>
<script>
import * as echarts from 'echarts/core';
import {
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  DataZoomComponent
} from 'echarts/components';
import { LineChart, PieChart } from 'echarts/charts';
import { UniversalTransition } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  LineChart,
  PieChart,
  CanvasRenderer,
  UniversalTransition,
  DataZoomComponent,
]);

export default {
  name: "TimeLine",
  props: {
    type: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  computed: {
    loading(){
      return !this.$store.state[this.type].loaded
    },
    data() {
      return this.$store.state[this.type].data
    },
    loansLoading(){
      return !this.$store.state.loans.loaded
    },
  },
  methods: {
    displayChart(){
      var myChart = echarts.init(this.$refs.chart);
      var option;

      const time = [7,6,5,4,3,2,1,0].map(i => ({
          value: this.$dayjs().startOfDay().subtract(i, "month"),
        }))
        time[time.length-1].value = this.$dayjs().startOfDay().add(1, "day").subtract(1, "minute");
        time.forEach((t,i) => {
          time[i].communities = this.data.filter(c => this.$dayjs(c.created_at).subtract(1, 'month').isBefore(t.value)).map(c => ({
              id: c.id,
              name: c.name,
              num: 0,
            }))
        })
        

        this.$store.state.loans.data.forEach(loan => {
          if(!loan.community) return;
          for( let i=1; i<time.length; i++ ){
            if( this.$dayjs(loan.departure_at).isBefore(time[i-1].value) ) {
              break;
            } else if(this.$dayjs(loan.departure_at).isBefore(time[i].value) ) {
              let j = time[i].communities.findIndex(c => c.id == loan.community.id)
              if( j > -1 && time[i].communities[j]) {
                time[i].communities[j].num++
              }
            }
          }
        })

        let monthsLabel = []
        let zero = []
        let one = []
        let twoFive= []
        let sixTen = []
        let more = []

        time.forEach((month,i) => {
          monthsLabel[i] = month.value.format('MMMM YYYY')
          zero[i] = 0
          one[i] = 0
          twoFive[i] = 0
          sixTen[i] = 0
          more[i] = 0
          month.communities.forEach(c => {
            if(c.num == 0) zero[i]++;
            else if(c.num == 1) one[i]++;
            else if(c.num <= 10) twoFive[i]++;
            else if(c.num <= 20) sixTen[i]++;
            else more[i]++
          })
        })

        option = {
          title: {
            text: 'Nombre de groupes - emprunts'
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          legend: {
            data: ['aucun', '1 emprunt', '2 à 10', '11 à 20', 'plus de 20'],
            top: 30,
          },
          color: ['#022f2e', '#005f5a', '#009689', '#00d5be', '#96f7e4' ],
          toolbox: {
            feature: {
              saveAsImage: {}
            }
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: monthsLabel.slice(1),
            }
          ],
          yAxis: [
            {
              type: 'value'
            }
          ],
          series: [
            {
              name: 'aucun',
              type: 'line',
              stack: 'Total',
              areaStyle: {},
              emphasis: {
                focus: 'series'
              },
              data: zero.slice(1)
            },
            {
              name: '1 emprunt',
              type: 'line',
              stack: 'Total',
              areaStyle: {},
              emphasis: {
                focus: 'series'
              },
              data: one.slice(1)
            },
            {
              name: '2 à 10',
              type: 'line',
              stack: 'Total',
              areaStyle: {},
              emphasis: {
                focus: 'series'
              },
              data: twoFive.slice(1)
            },
            {
              name: '11 à 20',
              type: 'line',
              stack: 'Total',
              areaStyle: {},
              emphasis: {
                focus: 'series'
              },
              data: sixTen.slice(1)
            },
            {
              name: 'plus de 20',
              type: 'line',
              stack: 'Total',
              areaStyle: {},
              emphasis: {
                focus: 'series'
              },
              data: more.slice(1)
            },
          ]
        };
      option && myChart.setOption(option);
    }
  },
  mounted() {
    if(!this.loading && !this.loansLoading) {
      this.displayChart()
    }
  },
  watch: {
    loading() {
      if(!this.loading && !this.loansLoading) {
        this.displayChart()
      }
    },
    loansLoading() {
      if(!this.loading && !this.loansLoading) {
        this.displayChart()
      }
    }
  }
}
</script>
